export const getPerspectivesList = (state) => state.perspectivesList;

export const getSelectedPerspective = (state) => state.selectedPerspective;

export const getDraftSelectedPerspective = (state) => state.draftSelectedPerspective;

export const getPerspectiveId = (state) => state.perspectiveId;

export const getPerspectiveDirty = (state) => state.perspectiveDirty;
